/**课程章节模块 */
import request from '../request/http';
/**初始化章节树新增 */
export function InitChapterTree(data){
    return request({
        url: '/sp/courseChapter/initChapterTree',
        method: 'post',
        data
    })
}
/**新增章节 */
export function AddChapter(data){
    return request({
        url: '/sp/courseChapter/addChapter',
        method: 'post',
        data
    })
}
/**修改章节 */
export function UpdateChapter(data){
    return request({
        url: '/sp/courseChapter/updateChapter',
        method: 'post',
        data
    })
}
/**删除章节 */
export function DelChapter(data){
    return request({
        url: '/sp/courseChapter/delChapter',
        method: 'post',
        data
    })
}
/**获取章节树 */
export function GetChapterTree(data){
    return request({
        url: '/sp/courseChapter/getChapterTree',
        method: 'post',
        data
    })
}
/**获取课程学习章节树 */
export function GetStudyChapterTree(data){
    return request({
        url: '/sp/courseChapter/getStudyChapterTree',
        method: 'post',
        data
    })
}
/**修改章节排序 */
export function UpdateChapterOrder(data){
    return request({
        url: '/sp/courseChapter/updateChapterOrder',
        method: 'post',
        data
    })
}